// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Contact ────────────────────────────────────────────── */
.contact-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg-surface);
}
@media (max-width: 768px) {
  .contact-section {
    padding: 60px 5%;
  }
}

.contact-header {
  text-align: center;
  margin-bottom: 48px;
}
.contact-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
}

.contact-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto 16px;
}

.contact-subtitle {
  color: var(--text-muted) !important;
  font-size: 0.95rem;
  max-width: 520px;
  margin: 0 auto;
  line-height: 1.7;
}

.contact-card {
  max-width: 600px;
  margin: 0 auto;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-links {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  color: var(--text) !important;
  transition: background 0.2s, border-color 0.2s;
}
.contact-link svg {
  font-size: 1.4rem !important;
  color: var(--accent) !important;
  flex-shrink: 0;
}
.contact-link:hover {
  background: var(--accent-soft);
  border-color: var(--border);
  opacity: 1;
}

.contact-link-body {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.contact-link-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--text-muted) !important;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
}

.contact-link-value {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text) !important;
}

.contact-availability {
  text-align: center;
  font-size: 0.825rem;
  color: var(--text-muted) !important;
  margin: 0;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}
.contact-availability::before {
  content: "● ";
  color: var(--accent-2);
  font-size: 0.6rem;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Contact.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,8CAAA;AAGF;AADE;EACE,4BAAA;EACA,+BAAA;EACA,cAAA;AAGJ;AAAE;EACE,8BAAA;EACA,2BAAA;EACA,UAAA;AAEJ;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,wDAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,SAAA;EACA,gBAAA;EACA,mCAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;AACJ","sourcesContent":["/* ─── Contact ────────────────────────────────────────────── */\n\n.contact-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg-surface);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.contact-header {\n  text-align: center;\n  margin-bottom: 48px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n  }\n}\n\n.contact-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto 16px;\n}\n\n.contact-subtitle {\n  color: var(--text-muted) !important;\n  font-size: 0.95rem;\n  max-width: 520px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n.contact-card {\n  max-width: 600px;\n  margin: 0 auto;\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.contact-links {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.contact-link {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  color: var(--text) !important;\n  transition: background 0.2s, border-color 0.2s;\n\n  svg {\n    font-size: 1.4rem !important;\n    color: var(--accent) !important;\n    flex-shrink: 0;\n  }\n\n  &:hover {\n    background: var(--accent-soft);\n    border-color: var(--border);\n    opacity: 1;\n  }\n}\n\n.contact-link-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.contact-link-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: var(--text-muted) !important;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n}\n\n.contact-link-value {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text) !important;\n}\n\n.contact-availability {\n  text-align: center;\n  font-size: 0.825rem;\n  color: var(--text-muted) !important;\n  margin: 0;\n  padding-top: 8px;\n  border-top: 1px solid var(--border);\n\n  &::before {\n    content: \"● \";\n    color: var(--accent-2);\n    font-size: 0.6rem;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
